import axios from 'axios';
import { D2D_API_KEY, D2D_API_URL } from '../const';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { 
    Authorization: 'Bearer ' + token, 
    'X-API-KEY': D2D_API_KEY 
    };
};

// API to get user's exports list and display status of ongoing exports
export const getUserExports = async () => {
  try {
    const response = await axios.get(`${D2D_API_URL}/user-exports?type=CIP`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user exports:', error);
    throw error;
  }
};

// API to download a specific file
export const downloadExportFile = async (exportId) => {
  try {
    const response = await axios.get(`${D2D_API_URL}/download-export/${exportId}`, {
      headers: authHeaders(),
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
};
